import { MutationTree, ActionTree } from 'vuex';
import { State } from '../types/customer';
import { loginApiClient } from '../utils/loginApiClient';

interface Customer extends Window {
  showLoginEmbed: any;
}

declare const window: Customer;

export const state: () => State = () => ({
  isInited: false,
  isLoggedIn: false,
  token: null,
  profile: null,
  modalVisible: false,
  activeSessions: 0,
  locale: 'lt',
});

export const mutations: MutationTree<State> = {
  setInitedStatus(state, isInited: State['isInited']) {
    state.isInited = isInited;
  },
  setLoggedInStatus(state, isLoggedIn: State['isLoggedIn']) {
    state.isLoggedIn = isLoggedIn;
  },
  setProfile(state, profile: State['profile']) {
    state.profile = profile;
  },
  setToken(state, token: State['token']) {
    state.token = token;
  },
  setModalState(state, isVisible: State['modalVisible']) {
    state.modalVisible = isVisible;
    if (state.modalVisible) {
      window.showLoginEmbed('login-modal', {
        modal: true,
        loginAnchorId: '_login',
        locale: state.locale,
      });
    }
  },
};

export const actions: ActionTree<State, Record<string, any>> = {
  async setCustomerData({ commit }, { data }: { data: Record<string, any> }) {
    const isServer = typeof window === 'undefined';
    const loginData = data?.loginStatus ? data : null;

    if (isServer) {
      return;
    }

    if (!loginData) {
      commit('setLoggedInStatus', false);
      return;
    }

    const client = loginApiClient();

    const customer = loginData.loginStatus ? loginData : null;
    const clientToken = customer ? await client.getToken() : null;

    commit('setProfile', customer);
    commit('setToken', clientToken);
    commit('setLoggedInStatus', !!customer && !!clientToken);
  },
  async logout({ commit }) {
    await loginApiClient().logout();
    commit('setLoggedInStatus', false);
    commit('setProfile', null);
    commit('setToken', null);
  },
  async init() {
    await loginApiClient().init();
  },
};
